<template>
    <div class="filter-wrapper">
        <div class="d-flex justify-content-between align-items-center">
            <div class="shops w-100" v-show="!filtersShown">
                <p class="shops__title shops__text eina-semibold">
                    Recommended shops
                </p>
                <p class="shops__description shops__text">
                    Recommendations are based on Alexa rank, monthly sales, product category.
                </p>
            </div>
            <div class="filter w-100">
                <button v-if="!filtersShown" @click="toggleFilters('Opened')" class="btn-outline filter__button ml-auto">
                    <Icon icon="filter-icon-shop"/>
                    Filter
                </button>
                <div v-else>
                    <div class="d-flex align-items-center">
                        <p class="filter__section-title">Filter By:</p>
                        <div class="filter__group">
                            <div class="filter__items">
                                <OrderBy @onOrder = "onAlexaRankOrder" />
                                <Dropdown 
                                    v-for="item in initialDropdownData"
                                    :key="item.key"
                                    :info = "item"
                                    :removed-item="removedItem"
                                    :reseted="reseted"
                                    @onCheck="onValueCheck"
                                    @clearRemovedItem="onValueRemove"
                                />
                            </div>
                            <div class="d-flex">
                                <Button 
                                    v-if="hasFilters"
                                    @click="clearFilters(true)" 
                                    class="btn-white eina-semibold filter__button reset_button">
                                    Reset
                                </Button>
                                <div class="line" v-if="hasFilters"></div>
                                <Button 
                                    @click="toggleFilters('Closed')" 
                                    class="btn-outline eina-semibold filter__button">
                                    <Icon icon="close-purple-outline" />
                                    <span style="line-height: 21px;">Close</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-list">
            <FilterItem 
                v-for="(item, index) in filterItems"
                :key="`${item}-${index}`"
                :filterItem="item"
                @onRemove="onValueRemove" 
            />
        </div>
    </div>
</template>

<script>
import Icon from '../../../Theme/Icon.vue'
import FilterItem from './FilterItem'
import useDropdown from '../../useDropdown.js'
import { ref, computed, onMounted } from '@vue/composition-api'
import {useRouter} from '../../../../core/hooks'
import Dropdown from './Dropdown'
import OrderBy from './OrderBy'
export default {
    name: 'Filters',
    components: {
        Dropdown,
        Icon,
        FilterItem,
        OrderBy
    },
    props: {
        filterItems: {
            type: Array,
            default: () => []
        }
    },
    setup(props, {emit, root}) {
        const { initialDropdownData } = useDropdown()
        const {route} = useRouter()
        const filtersShown = ref(false)
        const reseted = ref(false)
        const removedItem = ref()

        const onValueCheck = (item) => {
            emit('setFilter', item.key, item.checkedValues.map(item => item.value))
            reseted.value = false
        }

        const onAlexaRankOrder = val => {
            emit('setFilter', 'alexaRankOrder', val)     
        }

        const onValueRemove = (item) => {
            removedItem.value = item
        }
        
        onMounted(() => {
            if(route.value.query.filters) {
                filtersShown.value = true
            }
        })

        const hasFilters = computed(() => route.value.query.filters)

        const toggleFilters = param => {
            root.$sendMixpanelEvent(`Homepage Shops Filters ${param}`)
            root.$ga.event('Homepage Shops Filters', param)
            filtersShown.value = param === 'Opened'
            if(param === 'Closed') {
                clearFilters(false)
            }
        }
        const clearFilters = (sendEvent) => {
            if(sendEvent){
                root.$sendMixpanelEvent(`Homepage Shops Filters Resetted`)
                root.$ga.event('Homepage Shops Filters', 'Resetted')
            }
            reseted.value = true
            emit('reset')
        }
        return {
            initialDropdownData,
            onValueCheck,
            toggleFilters,
            filtersShown,
            onValueRemove,
            removedItem,
            clearFilters,
            reseted,
            onAlexaRankOrder,
            hasFilters
        }
    }
}
</script>

<style lang="scss" scoped>
$border_radius: 4px;
$border: 1px solid #CBD5E0;
$color: #333333;
$dropdown_text_color: #718096;
$font_size: 16px;
$line_height: 24px;
$padding: 8px 16px;
$button_color: #718096;
$button_fontsize: 16px;
$button_lineheight: 24px;
$button_padding: 8px 16px;
$button_radius: 8px;
$filter-list-hr: 1px solid #E2E8F0;
.shops {
    &__text {
        margin: 0;
    }
    &__title {
        font-size: 24px;
        line-height: 32px;
        color: #000000;
    }
    &__description {
        margin-top: 8px;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
    }
}
.filter-wrapper {
    padding: 8px 0;
    &.filter-fullwidth {
        width: 100%;
    }
}
.filter {
    &__button {
        height: 28px;
        padding: 4px 8px;
        font-size: 14px;
        display: flex;
        align-items: center;
        transition: 0.1s;

        &.reset_button {
            padding: 4px 16px;
        }

        img {
            margin-right: 8px;
            transition: 0.1s;
        }

        &:hover {
            img {
                filter: brightness(5)
            }
        }
    }
    &__section-title {
        font-size: $font_size;
        line-height: $line_height;
        color: $color;
        font-weight: bold;
        margin: 0;
    }
    &__group {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 24px;

        .line {
            background: #E2E8F0;
            width: 1px;
            height: 32px;
            margin: 0 16px;
            margin-top: -2px;
        }
    }
    &__items {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
    }
}
.filter-list {
    display: flex;
    border-top: $filter-list-hr;
    margin-top: 12px;
    flex-wrap: wrap;
    padding: 12px 0;
}
</style>